<template>
    <div>
        <!--Boards menu-->
        <SideMenu
            :show="showMenu == 'boards-menu'"
            :clearFilter="clearFilter"
            :boardOverviewFunc="boardOverviewFunc"
            @toggle-menu="showMenu = null"
        ></SideMenu>

        <slot @showUploadState="showUploadState"/>

        <VModal title="Add Member" ref="new-member">
            <label for="new-member-title">Email</label>

            <Textfield
                id="new-member-title"
                v-model="member.email"
                :placeholder="'Member Email'"
                :required="true"
            />

            <label for="member-role">Role</label>

            <div class="drop-down-style">
                <select
                    id="member-role"
                    name="member-role"
                    @change="onChangeMember($event)"
                >
                    <option value="member">Member</option>
                    <option value="owner">Owner</option>
                </select>
            </div>

            <div class="text-center">
                <VButton @clickHandler="createMember">Add</VButton>
            </div>
        </VModal>

        <VModal title="New board" ref="new-board">
            <label for="board-new-name">Board name</label>

            <Textfield
                id="board-new-name"
                v-model="board.title"
                :placeholder="'Board name'"
            />

            <div class="text-center">
                <VButton @clickHandler="createBoard">Create</VButton>
            </div>
        </VModal>

        <ConfirmDelete
            ref="confirm-delete-member"
            id="confirm-delete-member"
            title="member"
            @delete="deleteMember"
        />

        <ConfirmDelete
            ref="confirm-delete-board"
            id="confirm-delete-board"
            title="board"
            @delete="deleteBoard"
        />
    </div>
</template>

<script>
import {api} from "@/mixins/axios";
import Textfield from "../atoms/Textfield.vue";
import EventsTabs from "@/components/molecules/EventsTabs.vue";
import ConfirmDelete from "../organism/Confirm.vue";
import SideMenu from "@/components/SideMenu";
import { mapGetters } from 'vuex';
import VButton from "@/components/atoms/VButton.vue";
import VModal from "@/components/atoms/VModal.vue";

export default {
    name: "DashboardLayout",
    components: {
        ConfirmDelete,
        Textfield,
        EventsTabs,
        SideMenu,
        VButton,
        VModal
    },
    props: ["clearFilter", "boardOverviewFunc"],
    data() {
        return {
            showMenu: null,
            forceFromTemplate: false,
            board: {},
            members: [],
            deleteId: "",
            newBoard: {
                title: "",
                project: "",
            },
            member: {
                email: "",
                role: "member",
                project: "",
            },
            tags: [],
            selectedTags: null,
            activeEvents: 'this'
        };
    },
    computed: {
        activeBoard() {
            return this.$store.getters.activeBoard
        }
    },

    async mounted() {
        this.selectedTags = localStorage.getItem('selectedTags');
    },
    methods: {
        async deleteBoard() {
            try {
                const data = {
                    id: this.deleteId
                }
                await api.post(`/project_delete`, data);
                await this.getBoards()

            } catch (e) {}
        },
        async getBoards() {
            
        },
        async getMembers() {
            try {
                const response = await api.post(`/member_search`, {
                    page: 1,
                    paginate_by: 10,
                    board: this.activeBoard['id']
                });
                if (response.status === 200) {
                    this.members = response.data.data;
                }
            } catch (e) {
                console.error(e);
            }
        },
        async createMember() {
            const {role, email} = this.member;

            const data = {
                role,
                board: this.activeBoard['id'],
                email,
            };
            try {
                const response = await api.post("/member_create", data);
                if (response.status === 200) {
                    this.$refs['new-member'].hideModal()
                    this.getMembers();
                }
            } catch (e) {
                console.error(e);
            }
        },
        async createBoard() {
            try {
                const data = {
                    title: this.board.title,
                };
                const response = await api.post("/project_new", data);

                if (response.status === 200) {
                    this.$refs['new-board'].hideModal()
                    location.href = `/app/board/${response.data.data.id}`

                    await this.getBoards();
                }
            } catch (e) {
                console.error(e);
            }
        },
        onChangeMember(e) {
            this.member.role = e.target.value;
        },
        deleteMember() {},
        showUploadState(files, taskID) {
            console.log('showUploadState darshboard layout')
            console.log(this.$parent)
            this.$parent?.showUploadState(files, taskID)
        },
    },
};
</script>

<style scoped lang="scss">

.events-overview-card {
    height: 90%;
    width: calc(100% - 20px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 30px;
}

.events-overview-card .nav-btn-holder {
    font-size: 20px;
    display: flex;
    justify-content: center;
}

.events-overview-card .nav-btn {
    padding: 8px 16px;
}

.events-overview-card .nav-btn.active {
    color: $white;
}

.events-overview-card .nav-btn:hover {
    text-decoration: none;
}

.side-panel {
    position: absolute;
    left: 0;
    top: 0;
    background: #778beb;
    padding: 0;
    margin: 0;
    border: 1.5px solid black;
    border-radius: 5px;
    line-height: 1;
    z-index: 2;
    list-style: none;

    &.active {
        left: 400px;
    }

    a {
        display: block;
        padding: 6px;
        color: $white;
        font-size: 18px;
    }
}

.user-tag {
    background: #000;
    color: #fff;
    font-size: 16px;
    border-radius: 15px;
    padding: 10px;
    margin-bottom: 10px;
    display: inline-block;
    cursor: pointer;
    text-transform: capitalize;
}

.filter-by-member-head {
    color: white;
    font-size: 26px;
    margin-top: 30px;
    margin-bottom: 30px;
}

.members-list {
    padding: 0;
    margin: 0;
    list-style: none;

    li {
        display: flex;
        justify-content: space-between;
        padding: 5px 0;
    }

    .member-email {
        text-overflow: ellipsis;
        display: block;
        max-width: 270px;
        overflow: hidden;
    }

    a {
        &:hover {
            color: $white;
        }
    }
}
</style>
